"use client";

import { c as _c } from "react/compiler-runtime";
import { Progress as ProgressPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";
function Progress(t0) {
  const $ = _c(13);
  let className;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = value;
  } else {
    className = $[1];
    props = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = `translateX(-${100 - (value || 0)}%)`;
  let t3;
  if ($[6] !== t2) {
    t3 = <ProgressPrimitive.Indicator data-slot="progress-indicator" className="h-full w-full flex-1 bg-primary transition-all" style={{
      transform: t2
    }} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t3 || $[11] !== value) {
    t4 = <ProgressPrimitive.Root data-slot="progress" value={value} className={t1} {...props}>{t3}</ProgressPrimitive.Root>;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export { Progress };